import React, { useEffect, forwardRef, useImperativeHandle } from 'react'
import MaUTable from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useTable, useSortBy, usePagination, useGlobalFilter } from "react-table";
import { RiArrowDownSFill, RiArrowUpSFill } from "react-icons/ri"
import { BiEdit } from "react-icons/bi"
import Button from 'react-bootstrap/Button'
import './FeeDetailsTable.css'
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { MdFileDownload, MdFileDownloadOff } from 'react-icons/md'
import {HiArrowNarrowRight, HiArrowNarrowLeft} from "react-icons/hi"
import chequeAndDD from '../../assets/images/cheque-icon-22.jpg'
import chequeAndDDdisabled from '../../assets/images/cheque-icon-disabled-22.png'


const FeeDetailsTable = forwardRef(({selectedAcademicYear, academicData, studentsData, columns, data, setShowModal, setEditStudent, setShowDownloadPdfModal, setDownloadPdfModalDetails, setShowChequeOrDDModal, setChequeOrDDModalDetails}, ref) => {
    const { getTableProps,
        headerGroups,
        prepareRow,
        setGlobalFilter,
        state,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize, globalFilter }
    } = useTable({ columns, data, initialState: { pageIndex: 0 } }, useGlobalFilter, useSortBy, usePagination);


    const setFilter = (input) => {
        setGlobalFilter(input)
    }

    useImperativeHandle( ref, () => {
        return {
            setFilter: setFilter
        };
      });

    const editStudent = (studentDetails) => {
        delete studentDetails.Action
        Object.keys(studentDetails).map(each => studentDetails[each] === undefined && delete studentDetails[each])
        setEditStudent(studentDetails)
        setShowModal(true)
    }

    const onClickDownload = (row) => {
        let termsList = []
        Object.keys(row.original).map(key => {
            if(key.includes("Status") && row.original[key] === "Paid"){
                termsList.push(key.replace(" Status", ""))
            }
        })
        // if(termsList.length === 0){
        //     return alert("No Term Fee Paid")
        // }else{        }
        const studentFeeDetails = {termsList, admissionNumber: row.original.ADMISSION, academicYear: selectedAcademicYear}
        setDownloadPdfModalDetails(studentFeeDetails)
        setShowDownloadPdfModal(true)
    }

    const onClickViewDDorCheque = (row) => {
        let termsList = []
        // Object.keys(row.original).map(key => {
        //     if(key.includes("Status") && row.original[key] === "Paid"){
        //         termsList.push(key.replace(" Status", ""))
        //     }
        // })
        // let s = studentsData.filter((each) => {
        //     if(each.admissionNumber ===  row.original.ADMISSION){
        //         if(each['termFee'].filter(eachTerm => (eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.paymentType === "DD" || eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.paymentType === "Cheque")).length > 0){
        //             return each
        //         }
        //     }
        // }).length
        let student = studentsData.filter((each) => each.admissionNumber ===  row.original.ADMISSION)
        for (let eachTerm of student[0]['termFee']){
            if((eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.paymentType === "DD" || eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.paymentType === "Cheque") && (eachTerm[Object.keys(eachTerm)[0]]?.paymentStatus === 'Paid')){
                termsList.push(Object.keys(eachTerm)[0].replace(" Fee",""))
            }
        }
        const studentFeeDetails = {termsList,student:student[0]}
        setChequeOrDDModalDetails(studentFeeDetails)
        setShowChequeOrDDModal(true)
    }
    return (
        <>
            {!page?.length ?
                <h1 className='text-center'>No Records Found</h1> :
                <div style={{overflow:"auto"}}>
                    <MaUTable style={{ border: "1px solid #d6d6d6" }} {...getTableProps()}>
                        <TableHead>
                            {headerGroups.map((headerGroup,i) => (
                                <TableRow key={i} {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column, i) => (
                                        <TableCell key={i} {...column.getHeaderProps(column.getSortByToggleProps())}>

                                            <div style={{ display: "flex", alignItems: "center", fontSize:'12px'}}>
                                                {column.render("Header")}
                                                <span>
                                                    {column.isSorted
                                                        ? column.isSortedDesc
                                                            ? <RiArrowDownSFill style={{ marginTop: "5px" }} size={20} />
                                                            : <RiArrowUpSFill style={{ marginTop: "5px" }} size={20} />
                                                        : ''}
                                                </span>
                                            </div>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableHead>
                        <TableBody>
                            {page.map((row, i) => {
                                prepareRow(row);
                                return (
                                    
                                    <OverlayTrigger key={i} trigger={(row?.original?.isTermExists || ((row?.original?.message !== "Details are Valid") && (row?.original?.message))) ? ['hover', 'focus', 'click'] : "none"} overlay={<Tooltip style={{ fontSize: "20px" }}>{row?.original?.message ? row?.original?.message : "Term Already exists"}</Tooltip>}>
                                        <TableRow {...row.getRowProps()} style={{ border: (row?.original?.isTermExists || ((row?.original?.message !== "Details are Valid") && (row?.original?.message))) && "2px solid red " }} >
                                            {row.cells.map((cell,i) => {
                                            
                                                if (cell.column.Header === "Action") {
                                                    return (
                                                        <TableCell className='table-cell' key={i}>
                                                            <div className='d-flex align-items-center'>
                                                                { <BiEdit size={23} style={{ cursor: "pointer", marginRight:"10px" }} title="Edit" onClick={() => editStudent(row.values)}/>}

                                                                { Object.keys(row.original).filter(key => {
                                                                        return (key.includes("Status") && row.original[key] === "Paid")    
                                                                }).length === 0 ?  
                                                                <MdFileDownloadOff  size={28} style={{color:"#808080", marginRight:"10px"}}/>
                                                                    :
                                                                <MdFileDownload  size={28} style={{ cursor: "pointer", marginRight:"10px" }} title="Download" onClick={() => {onClickDownload(row)}}/>
                                                                }
                                                                { (Object.keys(row.original).filter(key => {
                                                                        return (key.includes("Status") && row.original[key] === "Paid")    
                                                                }).length !== 0 && studentsData.filter((each) => {
                                                                    if(each.admissionNumber ===  row.original.ADMISSION){
                                                                        if(each['termFee'].filter(eachTerm => (eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.paymentType === "DD" || eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.paymentType === "Cheque")).length > 0){
                                                                            return each
                                                                        }
                                                                    }
                                                                }).length > 0 )?
                                                                <img src={chequeAndDD} style={{ cursor: "pointer", marginRight:"10px", height:"30px", width:"30px" }} title="View Cheque or DD Details" onClick={() => {onClickViewDDorCheque(row)}} />
                                                                :
                                                                <img src={chequeAndDDdisabled} style={{ marginRight:"10px", height:"23px", width:"27px" }}  />
                                                                }
                                                            </div>
                                                        </TableCell>
                                                    )
                                                }

                                                return (
                                                    <TableCell key={i}  {...cell.getCellProps()}>
                                                        {/* {console.log("checkkkkk",cell.column.Header,cell.column.Header === "imgUrl")} */}
                                                        <span className={(cell.column.Header === "imgUrl") ? 'cell':''} style={{fontSize:'12px',padding:"5px",borderRadius:"5px",color:cell.column.Header.includes("Status") && cell.value && "#ffffff",backgroundColor:cell.column.Header.includes("Status") && cell.value && (row.original[cell.column.Header] === "Unpaid" ? " #e23030" : "#1ea354")}}>{cell.value ? cell.value : "NA"}</span>
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </OverlayTrigger>
                                );
                            })}
                        </TableBody>
                    </MaUTable>

                    {/* <div style={{ paddingTop: "20px" }}>
                        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                            {"<<"}
                        </button>{" "}
                        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
                            {"<"}
                        </button>{" "}
                        <button onClick={() => nextPage()} disabled={!canNextPage}>
                            {">"}
                        </button>{" "}
                        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                            {">>"}
                        </button>{" "}
                        <span>
                            Page{" "}
                            <strong>
                                {pageIndex + 1} of {pageOptions.length}
                            </strong>{" "}
                        </span>
                        <span>
                            | Go to page:{" "}
                            <input
                                type="number"
                                defaultValue={pageIndex + 1}
                                onChange={(e) => {
                                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                    gotoPage(page);
                                }}
                                style={{ width: "100px" }}
                            />
                        </span>{" "}
                        <select
                            value={pageSize}
                            onChange={(e) => {
                                setPageSize(Number(e.target.value));
                            }}
                        >
                            {[10, 20, 30, 40, 50, (data.length)].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                    {(pageSize === data.length) ? "Show All" : ("Show " + pageSize)}
                                </option>
                            ))}
                        </select>
                    </div> */}

            <div className="details-nav-container">
            <div>
                <span className="goto-indi">
                Page <strong>{pageIndex + 1}</strong> <span>of</span>
                <strong style={{marginRight:8}}> {pageOptions.length}</strong>
                </span>
                <span style={{marginRight:7, paddingBottom:5}}>
                {" "}
                |</span><span> Go to page:{" "}
                <input
                    type="number"
                    defaultValue={pageIndex + 1}
                    onChange={(e) => {
                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                    gotoPage(page);
                    }}
                    className="goto-input"
                />
                </span>{" "}
                <select
                value={pageSize}
                onChange={(e) => {
                    setPageSize(Number(e.target.value));
                }}
                className="select-pagesize"
                >
                {[10, 20, 30, 40, 50, data.length].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                    {pageSize === data.length ? "Show All" : "Show " + pageSize}
                    </option>
                ))}
                </select>
                </div>
                <div className="nav-btn-cont">
                <button className={canPreviousPage?"table-nav-btn":"disabled-nav-btn"} onClick={() => previousPage()} disabled={!canPreviousPage}><HiArrowNarrowLeft size={27} color="#7a325a"/>  Prev Page</button>
                <button className={canNextPage?"table-nav-btn":"disabled-nav-btn"} onClick={() => nextPage()} disabled={!canNextPage}>Next Page  <HiArrowNarrowRight size={27} color="#7a325a"/> </button>
                </div>
            </div>
            </div>}
        </>

    )
})

export default FeeDetailsTable